import {
  Box,
  Divider,
  Heading,
  HStack,
  Icon,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
} from "@chakra-ui/react";
import { FaPhone, FaStar } from "react-icons/fa";
import { MdPhotoCamera } from "react-icons/md";
import { VscTools } from "react-icons/vsc";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./App.css";
import ContactPanel from "./Components/ContactPanel";
import Header from "./Components/Header";
import PortfolioPanel from "./Components/PortfolioPanel";
import ServicesPanel from "./Components/ServicesPanel";
import TestimonialsPanel from "./Components/TestimonialsPanel";
import { RiToolsFill } from "react-icons/ri";

function App() {
  const [adminMode, setAdminMode] = useState(false);
  const location = useLocation();

  // Check if user navigates to `/adminsw` to enable admin mode
  useEffect(() => {
    if (location.pathname === "/adminsw") {
      const pin = prompt("Enter Admin PIN:");
      if (pin === "1234") {
        setAdminMode(true);
        alert("Admin mode enabled!");
      } else {
        alert("Incorrect PIN!");
      }
    }
  }, [location.pathname]);

  return (
    <Box bg={"gray.50"}>
      <Header />

      {/* Main Content with Tabs */}
      <Box p={6}>
        <HStack
          alignItems={"center"}
          spacing={2}
          align={"center"}
          mb={8}
          width={"100%"}
        >
          <Icon
            as={RiToolsFill}
            display={{ base: "none", md: "flex" }}
            fontSize={{ base: "30px", md: "30px" }}
          />
          <Heading as="h1" size={{ base: "sm", md: "lg" }} textAlign={{ base: "center", md: "start" }} w={"100%"}>
            Expert Handyman Services in Cannock and surrounding area
          </Heading>
        </HStack>

        <Tabs
          isLazy
          bg={"white"}
          isFitted
          variant="unstyled"
          borderRadius={"sm"}
          border={"1px solid"}
          borderColor={"gray.200"}
          boxShadow={"lg"}
          size={{ base: "xs", md: "md" }}
        >
          <TabList height={"40px"}>
            <Tab
              fontSize={{ base: "xs", md: "md" }}
              borderTopLeftRadius={"sm"}
              _selected={{ color: "white", bg: "blue.500" }}
            >
              <HStack spacing={{ base: 2, md: 4 }}>
                <VscTools /> <Text>Services</Text>
              </HStack>
            </Tab>
            <Tab
              fontSize={{ base: "xs", md: "md" }}
              _selected={{ color: "white", bg: "blue.500" }}
            >
              <HStack spacing={{ base: 2, md: 4 }}>
                <MdPhotoCamera /> <Text>Portfolio</Text>
              </HStack>
            </Tab>
            <Tab
              fontSize={{ base: "xs", md: "md" }}
              _selected={{ color: "white", bg: "blue.500" }}
            >
              <HStack spacing={{ base: 2, md: 4 }}>
                <FaStar /> <Text>Testimonials</Text>
              </HStack>
            </Tab>
            <Tab
              display={{ base: "none", sm: "flex" }}
              fontSize={{ base: "xs", md: "md" }}
              borderTopRightRadius={"sm"}
              _selected={{ color: "white", bg: "blue.500" }}
            >
              <HStack spacing={{ base: 2, md: 4 }}>
                <FaPhone /> <Text>Contact</Text>
              </HStack>
            </Tab>
          </TabList>
          <Divider />
          <TabPanels>
            <TabPanel>
              <ServicesPanel />
            </TabPanel>
            <TabPanel>
              <PortfolioPanel adminMode={adminMode} />
            </TabPanel>
            <TabPanel>
              <TestimonialsPanel adminMode={adminMode} />
            </TabPanel>
            <TabPanel>
              <ContactPanel />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
    </Box>
  );
}

export default App;
